/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { likeControllerFindById } from '../fn/like/like-controller-find-by-id';
import { LikeControllerFindById$Params } from '../fn/like/like-controller-find-by-id';
import { likeControllerFindByPickId } from '../fn/like/like-controller-find-by-pick-id';
import { LikeControllerFindByPickId$Params } from '../fn/like/like-controller-find-by-pick-id';
import { likeControllerFindByUserId } from '../fn/like/like-controller-find-by-user-id';
import { LikeControllerFindByUserId$Params } from '../fn/like/like-controller-find-by-user-id';
import { likeControllerSearchOffset } from '../fn/like/like-controller-search-offset';
import { LikeControllerSearchOffset$Params } from '../fn/like/like-controller-search-offset';
import { likeControllerUnLiked } from '../fn/like/like-controller-un-liked';
import { LikeControllerUnLiked$Params } from '../fn/like/like-controller-un-liked';
import { LikeDto } from '../models/like-dto';

@Injectable({ providedIn: 'root' })
export class LikeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `likeControllerSearchOffset()` */
  static readonly LikeControllerSearchOffsetPath = '/api/like/search/offset';

  /**
   * 좋아요 오프셋 기반 조회.
   *
   * 좋아요를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerSearchOffset$Response(params: LikeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
    return likeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요 오프셋 기반 조회.
   *
   * 좋아요를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerSearchOffset(params: LikeControllerSearchOffset$Params, context?: HttpContext): Observable<Array<LikeDto>> {
    return this.likeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LikeDto>>): Array<LikeDto> => r.body)
    );
  }

  /** Path part for operation `likeControllerFindById()` */
  static readonly LikeControllerFindByIdPath = '/api/like/{id}';

  /**
   * 좋아요 ID 기반 조회.
   *
   * 좋아요를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindById$Response(params: LikeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
    return likeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요 ID 기반 조회.
   *
   * 좋아요를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindById(params: LikeControllerFindById$Params, context?: HttpContext): Observable<LikeDto> {
    return this.likeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<LikeDto>): LikeDto => r.body)
    );
  }

  /** Path part for operation `likeControllerUnLiked()` */
  static readonly LikeControllerUnLikedPath = '/api/like/{id}';

  /**
   * 좋아요 삭제.
   *
   * 좋아요를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerUnLiked()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerUnLiked$Response(params: LikeControllerUnLiked$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
    return likeControllerUnLiked(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요 삭제.
   *
   * 좋아요를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerUnLiked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerUnLiked(params: LikeControllerUnLiked$Params, context?: HttpContext): Observable<LikeDto> {
    return this.likeControllerUnLiked$Response(params, context).pipe(
      map((r: StrictHttpResponse<LikeDto>): LikeDto => r.body)
    );
  }

  /** Path part for operation `likeControllerFindByPickId()` */
  static readonly LikeControllerFindByPickIdPath = '/api/like/pick/{pickId}';

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 좋아요를 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerFindByPickId()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByPickId$Response(params: LikeControllerFindByPickId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
    return likeControllerFindByPickId(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 좋아요를 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerFindByPickId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByPickId(params: LikeControllerFindByPickId$Params, context?: HttpContext): Observable<Array<LikeDto>> {
    return this.likeControllerFindByPickId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LikeDto>>): Array<LikeDto> => r.body)
    );
  }

  /** Path part for operation `likeControllerFindByUserId()` */
  static readonly LikeControllerFindByUserIdPath = '/api/like/my';

  /**
   * 로그인 회원 좋아요 조회.
   *
   * 로그인한 회원의 좋아요를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `likeControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByUserId$Response(params?: LikeControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LikeDto>>> {
    return likeControllerFindByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그인 회원 좋아요 조회.
   *
   * 로그인한 회원의 좋아요를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `likeControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  likeControllerFindByUserId(params?: LikeControllerFindByUserId$Params, context?: HttpContext): Observable<Array<LikeDto>> {
    return this.likeControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LikeDto>>): Array<LikeDto> => r.body)
    );
  }

}
